<template>
<div class="chapter">
<div class="inner_page">
<p class="cen"><em>Write your own bloody bibles!</em><br/>—Colin Vearncombe</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm03.vue?7b8b432a